// src/components/utils/sidebar/Sidebar.tsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  History,
  Boxes,
  Store,
  Tag,
  Handshake,
  Layers,
  Bell,
  Receipt,
  CreditCard,
  Clock,
} from "lucide-react";

interface SidebarProps {
  sidebarOpen: boolean;
  handleLinkClick: () => void;
  role: string;
}

const Sidebar: React.FC<SidebarProps> = ({ sidebarOpen, handleLinkClick, role }) => {
  const location = useLocation();

  const getLinkClass = (path: string) => {
    return `flex items-center gap-3 p-2 rounded-md transition-colors ${
      location.pathname === path
        ? "bg-blue-100 text-blue-700 font-semibold"
        : "hover:bg-gray-100"
    }`;
  };

  return (
    <aside
      className={`fixed top-0 left-0 h-full z-40 bg-white shadow-md transform transition-transform duration-300 ease-in-out ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      } w-64 pt-16 overflow-y-auto`}
    >
      <nav className="px-4 text-gray-700 space-y-2 pb-6">
        {role === "admin" && (
          <Link
            to="/"
            onClick={handleLinkClick}
            className={getLinkClass("/")}
          >
            <LayoutDashboard className="h-5 w-5" />
            Dashboard
          </Link>
        )}

        {/* SECCIÓN DE CAJA - Disponible para todos */}
        <h4 className="mt-4 mb-1 text-xs font-semibold text-gray-500 uppercase">Caja</h4>
        <Link
          to="/caja"
          onClick={handleLinkClick}
          className={getLinkClass("/caja")}
        >
          <CreditCard className="h-5 w-5" />
          Gestión de Caja
        </Link>
        <Link
          to="/caja/historial"
          onClick={handleLinkClick}
          className={getLinkClass("/caja/historial")}
        >
          <Clock className="h-5 w-5" />
          Historial de Cajas
        </Link>

        {role === "admin" && (
          <>
            <h4 className="mt-4 mb-1 text-xs font-semibold text-gray-500 uppercase">Ingresos</h4>
            <Link
              to="/historico"
              onClick={handleLinkClick}
              className={getLinkClass("/historico")}
            >
              <History className="h-5 w-5" />
              Histórico de Ventas
            </Link>
          </>
        )}

        {role === "admin" && (
          <>
            <h4 className="mt-4 mb-1 text-xs font-semibold text-gray-500 uppercase">Gastos</h4>
            <Link
              to="/gastos"
              onClick={handleLinkClick}
              className={getLinkClass("/gastos")}
            >
              <Receipt className="h-5 w-5" />
              Gestionar Gastos
            </Link>
          </>
        )}

        <h4 className="mt-4 mb-1 text-xs font-semibold text-gray-500 uppercase">Inventario</h4>
        <Link
          to="/inventario"
          onClick={handleLinkClick}
          className={getLinkClass("/inventario")}
        >
          <Boxes className="h-5 w-5" />
          Productos
        </Link>

        {role === "admin" && (
          <>
            <Link
              to="/sucursales"
              onClick={handleLinkClick}
              className={getLinkClass("/sucursales")}
            >
              <Store className="h-5 w-5" />
              Sucursales
            </Link>
            <Link
              to="/categorias"
              onClick={handleLinkClick}
              className={getLinkClass("/categorias")}
            >
              <Tag className="h-5 w-5" />
              Categorías
            </Link>
            <Link
              to="/proveedores"
              onClick={handleLinkClick}
              className={getLinkClass("/proveedores")}
            >
              <Handshake className="h-5 w-5" />
              Proveedores
            </Link>
            <Link
              to="/marcas"
              onClick={handleLinkClick}
              className={getLinkClass("/marcas")}
            >
              <Layers className="h-5 w-5" />
              Marcas
            </Link>
          </>
        )}

        <h4 className="mt-4 mb-1 text-xs font-semibold text-gray-500 uppercase">Alertas</h4>
        <Link
          to="/notificaciones"
          onClick={handleLinkClick}
          className={getLinkClass("/notificaciones")}
        >
          <Bell className="h-5 w-5" />
          Notificaciones
        </Link>
      </nav>
    </aside>
  );
};

export default Sidebar;